module.exports = __webpack_public_path__ + "img/1f9f2.61cbcf5.svg";